'use client'

import React from 'react'
import {useTranslations} from 'next-intl'

import {reorderObj} from '../utils'
import {useToolInfo} from '../../../../contexts/toolInfo'
import CodeComparerLayout from '../CodeComparerLayout'


export default function JSONComparer() {
  const t = useTranslations()
  const toolInfo = useToolInfo()

  const lang = 'json'
  const format = (value) => {
    value = reorderObj(JSON.parse(value))
    return JSON.stringify(value, null, 2)
  }

  return (
    <CodeComparerLayout
      format={format}
      dataFormat={lang}

      leftInputLabel={t(`${toolInfo.key}.left-input-label`)}
      leftInputDescription={t(`${toolInfo.key}.left-input-description`)}
      rightPanelLabel={t(`${toolInfo.key}.right-input-label`)}
      rightPanelDescription={t(`${toolInfo.key}.right-input-description`)}
    />
  )
}